import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { InventoryDebitData } from '../../bean/Inventory';

import { MatSnackBar } from '@angular/material';
import { MessageComponent } from '../../Generic/message/message.component';

@Component({
    selector: 'PopupAcceptRequest',
    templateUrl: 'accepttransfer.html',
})
export class PopUpAcceptRequest {

   
   comments:String;

   submitted:boolean=false;
   acceptTransferForm: FormGroup;

    constructor(public dialogRef: MatDialogRef<PopUpAcceptRequest>,  private snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: InventoryDebitData,private formBuilder: FormBuilder
        )
    {      

        this.acceptTransferForm = this.formBuilder.group({
            
              comments: ['', Validators.required]
          });
       

    }


  
    
    onCancelClick(): void {
        this.dialogRef.close(null);
    }

    openSnackBar(message:string) {
        this.snackBar.openFromComponent(MessageComponent, {
          data: message,
          duration:5*1000
        });
      }
    

    onSubmit(): void {

        this.submitted=true;

        if(this.acceptTransferForm.invalid)
        {
            return;
        }
       
        this.dialogRef.close(this.comments);

    }

   

}